<ng-container *ngIf="newCarrierForm && groupedAdditionalOptions">
  <ng-container *ngFor="let option of groupedAdditionalOptions.coverage.options">
    <app-new-carrier-rates-option [control]="newCarrierForm.controls[option.uid]" [option]="option"></app-new-carrier-rates-option>
  </ng-container>
  <mat-accordion style="margin-top: 10px">
    <mat-expansion-panel
        *ngIf="groupedAdditionalOptions.additional_coverage.options && groupedAdditionalOptions.additional_coverage.options.length"
        [expanded]="hasPetsAttribute"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div>
            <div class="residential-accordion__title">{{'residential.additional_coverage_options' | translate}} ({{'residential.optional_option' | translate}}):</div>
            <div class="residential-accordion__description">{{'residential.additional_coverage_options_description' | translate}}</div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="column" *ngFor="let option of groupedAdditionalOptions.additional_coverage.options">
        <app-new-carrier-rates-option [control]="newCarrierForm.controls[option.uid]" [option]="option"></app-new-carrier-rates-option>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div>
            <div class="residential-accordion__title">{{'residential.deductible_options' | translate}}:</div>
            <div class="residential-accordion__description">{{'residential.deductible_options_description' | translate}}</div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div fxLayout="column" *ngFor="let option of groupedAdditionalOptions.deductible.options">
        <app-new-carrier-rates-option
          [control]="newCarrierForm.controls[option.uid]"
          [option]="option">
        </app-new-carrier-rates-option>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

</ng-container>
